module.exports = __webpack_public_path__ + "static/media/bg-five.d04609d8.png";